const debitConstants = {
    SET_DEBIT_SUCCESS:'SET_DEBIT_SUCCESS',

    CLEAR: 'DEBIT_CLEAR',
}

export default debitConstants